module.exports = __webpack_public_path__ + "static/fonts/NeueAugenblick-Medium.a16976ca.woff2";